export function getDeviceTypeTranslate(device_type) {
    if (device_type === 'H1V') {
        return 'h1';
    }
    if (device_type === 'SMART' || device_type === 'SMART_ZOTA') {
        return 'smart';
    }
    return null;
}
